module.exports = __webpack_public_path__ + "img/more_circle.e7940d54.svg";